import { gql } from '@apollo/client';

export const GetObjectGroupQueryName = 'GetObjectGroup';

export const GET_OBJECT_GROUP_QUERY = gql`
  query ${GetObjectGroupQueryName}($id: String!) {
    getObjectGroup(id: $id) {
      id
      createdAt
      createdBy
      name
      description
      shared
      level
      collaborators {
        id
        createdAt
        userId
        groupId
        level
        email
        displayName
      }
    }
  }
`;
